"use strict";const e=require("react").lazy(()=>Promise.resolve().then(function(){return require("./index-cjs-BvlpVwqY.js")}));exports.DrawerCartV3=e;